import React, { useEffect, useState } from 'react';

import nexo from '../../nexoClient';

import { Page, Layout } from '@nimbus-ds/patterns';
import {
  Box,
  IconButton,
  Pagination,
  Sidebar,
  Spinner,
  Table,
  Text,
} from '@nimbus-ds/components';
import { navigateHeader } from '@tiendanube/nexo';
import { useTranslation } from 'react-i18next';
import apiInstance from '../../utils/apiUtils';
import { IEventLogListResponse } from '../../lib/interfaces/events.interfaces';
import { EyeIcon } from '@nimbus-ds/icons';
import { formatDate } from '../../utils/formatUtils';

const EventsPage: React.FC = () => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState<boolean>(true);
  const [events, setEvents] = useState<IEventLogListResponse | null>(null);
  const [open, setOpen] = useState<boolean>(false);
  const [selectedInfo, setSelectedInfo] = useState<{ [key: string]: any }>({});

  useEffect(() => {
    navigateHeader(nexo, { goTo: '/', text: `${t('General.back')}` });
    getEvents();
  }, []);

  const getEvents = async (page = 1) => {
    try {
      const result = await apiInstance.get(`/app/events?page=${page}`);
      setEvents({ ...(result.data as IEventLogListResponse) });
    } catch (error) {
      console.error(error);
      setEvents(null);
    }
    setLoading(false);
  };

  return (
    <Page>
      <Page.Header title="Eventos/Logs" />
      <Page.Body>
        <Layout columns="1">
          <Layout.Section>
            {loading ? (
              <Box
                paddingTop="10"
                paddingBottom="10"
                display="flex"
                alignItems="center"
                gap="4"
              >
                <Spinner size="large" />
                <Text>{t('General.loading_text')}</Text>
              </Box>
            ) : (
              <Box display="grid" gap="6">
                {events && (
                  <>
                    <Table>
                      <Table.Head>
                        <Table.Row>
                          <Table.Cell width="100px" as="th">
                            Tipo
                          </Table.Cell>
                          <Table.Cell as="th">Mensagem</Table.Cell>
                          <Table.Cell width="140px" as="th">
                            Data
                          </Table.Cell>
                          <Table.Cell width="50px" as="th">
                            {''}
                          </Table.Cell>
                        </Table.Row>
                      </Table.Head>
                      <Table.Body>
                        {events.data.map((event) => (
                          <Table.Row key={event._id}>
                            <Table.Cell>
                              <Text
                                color={
                                  event.success === true
                                    ? 'success-interactive'
                                    : 'danger-interactive'
                                }
                              >
                                {event.type}
                              </Text>
                            </Table.Cell>
                            <Table.Cell>{event.message}</Table.Cell>
                            <Table.Cell>
                              {formatDate(event.createdAt || '')}
                            </Table.Cell>
                            <Table.Cell>
                              <IconButton
                                size="26px"
                                onClick={() => {
                                  setSelectedInfo(event.meta);
                                  setOpen(true);
                                }}
                                source={<EyeIcon size="small" />}
                              />
                            </Table.Cell>
                          </Table.Row>
                        ))}
                      </Table.Body>
                    </Table>
                    <Pagination
                      activePage={events.page}
                      onPageChange={getEvents}
                      pageCount={Math.ceil(events.total / events.limit)}
                    />
                  </>
                )}
              </Box>
            )}
          </Layout.Section>
        </Layout>
        <Sidebar
          maxWidth="900px"
          padding="base"
          open={open}
          onRemove={() => {
            setOpen(false);
            setSelectedInfo({});
          }}
        >
          <Sidebar.Header title="Detalhes" />
          <Sidebar.Body>
            <Table>
              <Table.Body>
                {Object.entries(selectedInfo).map(([key, value]) => (
                  <Table.Row key={key}>
                    <Table.Cell width="30%" as="th">
                      {key}
                    </Table.Cell>
                    <Table.Cell>{JSON.stringify(value)}</Table.Cell>
                  </Table.Row>
                ))}
              </Table.Body>
            </Table>
          </Sidebar.Body>
        </Sidebar>
      </Page.Body>
    </Page>
  );
};

export default EventsPage;
